import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Beheertools() {
  const navigate = useNavigate();

  const tools = [
    {
      to: '/beheertools/bulk-import',
      titel: 'Bulk-import CSV',
      omschrijving: 'Eenmalig veel houders, inrichtingen en putten tegelijk inlezen vanuit een CSV-bestand.',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="9" y1="13" x2="15" y2="13"/>
          <line x1="9" y1="17" x2="15" y2="17"/>
        </svg>
      ),
    },
    {
      to: '/beheertools/kaart-stijlen',
      titel: 'Kaart-stijlen',
      omschrijving: 'Pas kleuren, transparantie en patronen aan voor alle gebiedlagen op de kaarten. Wijzigingen gelden direct voor iedereen.',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="13.5" cy="6.5" r="2.5"/>
          <circle cx="17.5" cy="10.5" r="2.5"/>
          <circle cx="8.5" cy="7.5" r="2.5"/>
          <circle cx="6.5" cy="12.5" r="2.5"/>
          <path d="M12 22a10 10 0 1 1 0-20c5.523 0 10 4.477 10 10 0 1.54-.5 3-1.5 3.5-1 .5-2 0-2.5-.5-1-1-2-1-3-1-1.5 0-2 1-1 2.5 1 1.5 1.5 2.5.5 3.5-.5.5-1.5 1-2.5 1z"/>
        </svg>
      ),
    },
    {
      to: '/beheertools/productie-overzicht',
      titel: 'Opvraag-overzicht',
      omschrijving: 'Bekijk per opgavejaar welke inrichtingen hun kwartaalcijfers al hebben doorgegeven en welke nog openstaan.',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      ),
    },
    {
      to: '/beheertools/productie-uitnodigingen',
      titel: 'Productieopgaven versturen',
      omschrijving: 'Stuur in één keer alle inrichtinghouders een uitnodiging om hun jaarlijkse kwartaalcijfers (m³) door te geven. Alleen wie nog niet compleet is, krijgt een mail.',
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16v16H4z"/>
          <path d="M22 6l-10 7L2 6"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="main-inner">
      <div className="page-header">
        <div>
          <h1 className="page-title">Beheertools</h1>
          <p className="page-subtitle">Hulpmiddelen voor het in bulk verwerken van gegevens</p>
        </div>
      </div>

      <div className="card-grid">
        {tools.map(t => (
          <div
            key={t.to}
            className="card clickable"
            onClick={() => navigate(t.to)}
            style={{ cursor: 'pointer', display: 'flex', gap: 16 }}
          >
            <div style={{
              width: 56, height: 56, flexShrink: 0,
              borderRadius: 'var(--radius)',
              background: 'var(--accent-soft)',
              color: 'var(--accent)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {t.icon}
            </div>
            <div>
              <h3 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 6px' }}>{t.titel}</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0, lineHeight: 1.5 }}>
                {t.omschrijving}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
